module.exports = __webpack_public_path__ + "img/Group 679.b00a0c62.png";